



















































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import RevisitApi from '@/api/revisit'
import { TIAN_KONG, DUO_XUAN, DAN_XUAN } from '../questionnaire/const'
import MultipleInputs from '@/utils/MultipleInputs'

@Component({})
export default class QuestionForm extends Vue {
	private TIAN_KONG = TIAN_KONG
	private DUO_XUAN = DUO_XUAN
	private DAN_XUAN = DAN_XUAN
	private addForm: any = {}
	private saving = false
	private multipleInstance = new MultipleInputs()
	private otherOptionArr: number[] = [] // 属于其他选项的选项id数组

	@Prop({})
	private question!: any

	@Prop({ default: false })
	private visible!: boolean

	@Watch('question', { immediate: true })
	private onQuestionChange() {
		if (!this.question) {
			return
		}

		this.otherOptionArr = []
		this.multipleInstance = new MultipleInputs(
			this.question.optionList && this.question.optionList.length
		)
		const optionList: any[] = []
		this.multipleInstance.idArr.forEach((id: number, index: number) => {
			optionList[id] = this.question.optionList[index]
			if (optionList[id] && optionList[id].optionType === '1') {
				this.otherOptionArr.push(id)
			}
		})

		this.addForm.setFieldsValue({
			questionType: this.question.questionType,
		})
		this.$nextTick(() => {
			this.addForm.setFieldsValue({
				question: this.question.question,
				optionList,
			})
		})
	}

	private get isAdd() {
		return !(this.question && this.question.questionId)
	}

	private handleOk() {
		this.addForm.validateFields((err: any, values: any) => {
			if (!err) {
				if ([DUO_XUAN, DAN_XUAN].includes(values.questionType)) {
					// 校验选项
					if (!(values.optionList && values.optionList.length > 0)) {
						return this.$message.error('请添加选项')
					}

					const optionList: any[] = []
					this.multipleInstance.idArr.forEach((id: number) => {
						optionList.push({
							optionType: this.otherOptionArr.includes(id) ? '1' : '0',
							...values.optionList[id],
						})
					})
					values.optionList = optionList
				}

				this.saving = true
				const promise = this.isAdd
					? RevisitApi.addQuestion(values)
					: RevisitApi.updateQuestion({
							...values,
							questionId: this.question.questionId,
					  })
				promise
					.then(() => {
						this.saving = false
						this.$emit('update:visible', false)
						this.reset()
						this.$message.success(`${this.isAdd ? '新增' : '编辑'}题目成功`)
						this.$emit('finish')
					})
					.finally(() => {
						this.saving = false
					})
			}
		})
	}

	private reset() {
		this.addForm.resetFields()
		this.multipleInstance.reset()
		this.otherOptionArr = []
	}

	private handleCancel() {
		this.reset()
		this.$emit('update:visible', false)
	}

	private removeOption(index: number) {
		this.multipleInstance.remove(index)
	}

	private addOption() {
		const res = this.multipleInstance.add()
		if (!res) {
			this.$message.error(`最多添加${this.multipleInstance.MAX}项`)
		}
	}

	private addOtherOption() {
		const res = this.multipleInstance.add({
			callback: (uniqueId: number) => {
				this.otherOptionArr.push(uniqueId)
			},
		})
		if (!res) {
			this.$message.error(`最多添加${this.multipleInstance.MAX}项`)
		}
	}

	private created() {
		this.addForm = this.$form.createForm(this)
	}
}
